function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Actions from '@nextcloud/vue/dist/Components/Actions';
import ActionButton from '@nextcloud/vue/dist/Components/ActionButton';
import Vuex from 'vuex';
export default {
  name: 'Table',
  components: {
    Actions: Actions,
    ActionButton: ActionButton
  },
  props: {
    favorites: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stationData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      activeItem: null
    };
  },
  computed: _objectSpread(_objectSpread({}, Vuex.mapGetters(['isFavorite'])), {}, {
    isFolder: function isFolder() {
      if (this.stationData[0]) {
        if (this.stationData[0].type === 'folder') {
          return true;
        }
      }

      return false;
    }
  }),
  methods: {
    doPlay: function doPlay(idx, station) {
      this.activeItem = idx;
      this.$emit('doPlay', station);
    },
    doFavor: function doFavor(idx, station) {
      this.$emit('doFavor', station);
    },
    toggleSidebar: function toggleSidebar(station) {
      this.$emit('toggleSidebar', station);
    },
    changeRoute: function changeRoute(path) {
      this.$router.push({
        path: path
      });
    }
  }
};